import { Carousel } from '@eventbrite/eds-carousel';
import {
    CONSUMER_CARD_DEFAULTS,
    EventCard,
    FormattedEvent,
} from '@eventbrite/event-renderer';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import '../../styles/related-events.scss';
import {
    label,
    shareType,
    trackShareAction,
} from '../../tracking/trackShareAction';
import { AffiliateCodes, GACodes } from '../../types';
import { ShareProps } from '../ShareEvent/ShareEventRoot';
import { RelatedEventsChildrenProps } from './RelatedEvents';

const CAROUSEL_HEADING = gettext('Other events you may like');

const getEventCardMap = ({
    events,
    isAuthenticated,
    shareComponentProps,
}: {
    events: FormattedEvent[] | undefined;
    isAuthenticated: boolean;
    shareComponentProps: ShareProps;
}): JSX.Element[] => {
    if (events == undefined) {
        return [];
    }

    return events.map((event: FormattedEvent) => {
        const shareEventProps = {
            eventId: event.id,
            eventName: event.name,
            eventUrl: event.url,
            ...shareComponentProps,
        };

        return (
            <EventCard
                {...CONSUMER_CARD_DEFAULTS}
                affCode={AffiliateCodes.AFF_RELATED_EVENTS_LIVE}
                key={event.id}
                eventData={event}
                gaCategory="related-events"
                isAuthenticated={isAuthenticated}
                shareOptions={shareEventProps}
                onDidShareClick={(id: shareType) =>
                    trackShareAction(label(id), GACodes.GA_CATEGORY_EVENT_CARD)
                }
                onWillShareClick={() =>
                    trackShareAction(
                        GACodes.GA_LABEL_OPEN_MODAL,
                        GACodes.GA_CATEGORY_EVENT_CARD,
                    )
                }
            />
        );
    });
};

const OtherEventsYouMayLike = (props: RelatedEventsChildrenProps) => {
    const eventCardMap = getEventCardMap({
        events: props.events,
        isAuthenticated: props.isAuthenticated,
        shareComponentProps: props.shareComponentProps,
    });

    const wrapEventCardMapForDesktop = () => {
        const slides = [];

        for (let i = 0; i < eventCardMap.length; i += 3) {
            const slideItem = eventCardMap.filter(
                (_, index) => index >= i && index < i + 3,
            );
            slides.push(slideItem);
        }
        return slides;
    };

    const eventCardMapForDesktop = wrapEventCardMapForDesktop().map(
        (slide, index) => {
            return (
                <div className="desktop-slide" key={index}>
                    {slide}
                </div>
            );
        },
    );
    if (!props.events || props.events.length <= 0) {
        return null;
    }
    return (
        <section className="related-events g-grid g-grid--page-margin-manual">
            <div className="eds-g-cell eds-g-cell--has-overflow eds-g-cell-1-1 eds-l-pad-hor-5 eds-l-ln-pad-hor-0 eds-l-lg-pad-hor-0 eds-l-lw-pad-hor-0 eds-l-mar-bot-16">
                <div className="eds-show-up-mn" data-testid="carousel-desktop">
                    <Carousel
                        hasTopControls={true}
                        isNotContinuous={true}
                        alwaysShowSideNavigation={true}
                        usesNewStyle={true}
                        title={CAROUSEL_HEADING}
                        fullWidth={true}
                    >
                        {eventCardMapForDesktop}
                    </Carousel>
                </div>

                <div
                    className="eds-show-down-sw carousel-mobile"
                    data-testid="carousel-mobile"
                >
                    <Carousel
                        alwaysShowSideNavigation={true}
                        hasTopControls={true}
                        isNotContinuous={true}
                        usesNewStyle={true}
                        title={CAROUSEL_HEADING}
                        fullWidth={true}
                    >
                        {eventCardMap}
                    </Carousel>
                </div>
            </div>
        </section>
    );
};

export default OtherEventsYouMayLike;
